import { ChangeDetectionStrategy, Component, HostBinding, input, output } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { MenuItem } from 'src/app/home/shared/models';

@Component({
  selector: 'app-card-menu',
  templateUrl: './card-menu.component.html',
  styleUrls: ['./card-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgTemplateOutlet]
})
export class HomepageCardMenuComponent {
  cardItem = input.required<MenuItem>();
  parentTitle = input<string>();

  toggleFavorite = output<MenuItem>();
  parentClicked = output<MenuItem>();

  @HostBinding('class')
  get hostClasses(): { [key: string]: boolean } {
    const classes: { [key: string]: boolean } = {
      'card-container-host': true
    };
    return classes;
  }

  emitCardClick(item: MenuItem): void {
    if (item.link) {
      window.open(item.link, '_blank');
      return;
    }
    this.parentClicked.emit(item);
  }

  iconGenerate(item: MenuItem): string {
    const stringGenerate = (name: string) =>
      name
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^\w-]/g, '');

    if (item.icon) {
      return item.icon;
    }

    const pathGenerated = stringGenerate(item.title);

    return `assets/images/icons/homepage/${pathGenerated}.svg`;
  }

  onToggleFavorite(event: Event, item: MenuItem): void {
    event.stopPropagation();
    this.toggleFavorite.emit(item);
  }
}
